import i18n from '../../../i18n/index';
export const defFlagObj = {
    0: i18n.t(`dataManage.vehicleEnclosure.emun.正常`),
    1: i18n.t(`dataManage.vehicleEnclosure.emun.默认`),
}

export const templateTypeObj = {
    big_bag: i18n.t(`dataManage.vehicleEnclosure.emun.大包`),
    ordinary: i18n.t(`dataManage.vehicleEnclosure.emun.普通`),
}

export const attrFileTypeObj = {
    img:i18n.t(`dataManage.vehicleEnclosure.emun.图片`),
    file:i18n.t(`dataManage.vehicleEnclosure.emun.文件`)
}

export const requiredObj = {
    0: i18n.t(`dataManage.vehicleEnclosure.emun.正常`),
    1: i18n.t(`dataManage.vehicleEnclosure.emun.必填`),
}

export const disableFlagObj = {
    0: i18n.t(`dataManage.vehicleEnclosure.emun.正常`),
    1: i18n.t(`dataManage.vehicleEnclosure.emun.禁用`),
}